import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PageLayout from '../components/templates/page-layout/page-layout'
import CapacidadesInternas from "../components/organisms/capacidades-internas/capacidades-internas"
import SEO from "../shared/components/atoms/seo/seo"

import useMobile from '../shared/hooks/useMobile'

const CapacidadesInternasPage = () => {

  const isMobile = useMobile()

  const resultQueryCapacidades = useStaticQuery(
    graphql`
    query INNGENIO_QUERY_CAPACIDADES {
      allContentfulInngenio(filter: {slug: {eq: "inngenio/capacidades-internas"}}) {
        nodes {
          metaTitulo
          metaDescripcion {
            metaDescripcion
          }
          slug
          imagenesBanner {
            file {
              url
              fileName
            }
            title
          }
          tituloIndicador
          porcentajeIndicador
          descripcionIndicador
          tituloPrincipal
          descripcionPrincipal {
            json
          }
          tituloSecundario
          urlDelVideoSecundario
          referenciaDestacadosSecundarias {
            imagenDelDestacado {
              file {
                fileName
                url
              }
            }
            descripcionDelDestacado {
              json
            }
            nombreDelDestacado
            nombreRedireccion
            redireccionDelDestacado
          }
          tituloBanner
          iconoBanner {
            file {
              fileName
              url
            }
          }
          descripcionBanner {
            json
          }
          imagenPrincipal {
            file {
              url
              fileName
            }
          }
          ctaNombrePrincipal
          ctaRedireccionPrincipal
          descripcionSecundaria {
            json
          }
          ctaNombreSecundario
          ctaRedireccionSecundaria
          imagenSecundaria {
            file {
              fileName
              url
            }
          }
          ctaNombreTerciario
          descripcinTerciaria {
            json
          }
          imagenTerciaria {
            file {
              url
              fileName
            }
          }
          informacionCuaternaria {
            json
          }
          ctaNombreCuaternario
          imagenCuaternaria {
            file {
              fileName
              url
            }
          }
          ctaRedireccionCuaternario
        }
      }
    }
    `
  );

  const [globalSession, setglobalSession] = useState(null)
  const metaData = resultQueryCapacidades.allContentfulInngenio.nodes[0]

  return (
    <PageLayout isMobile={isMobile} setglobalSession={setglobalSession} globalSession={globalSession}>
      <div className="f-container-inngenio">
        <SEO
          title={metaData.metaTitulo}
          description={metaData.metaDescripcion?.metaDescripcion}
          slug={metaData.slug}
          lang="ES"
        />
        <CapacidadesInternas
          resultQueryCapacidades={resultQueryCapacidades.allContentfulInngenio.nodes}
          isMobile={isMobile}
        />
      </div>
    </PageLayout>
  )
}

export default CapacidadesInternasPage